// Module
var code = "<tr class=\"table-head\"> <th><!-- ko text: _labels.USER --><!-- /ko --></th> <th><!-- ko text: _labels.FIELD_COLLECTION --><!-- /ko --></th> </tr>";
// Exports
export default code;